import { ReactNode } from "react";

import Filters from "components/Filters";
import FiltersContentWrapper from "components/Filters/ContentWrapper";
import FiltersMobileTriggerButton from "components/Filters/MobileTriggerButton";
import FiltersSidebar from "components/Filters/Sidebar";
import FiltersSplit from "components/Filters/Split";
import { FilterItem, FiltersItemsOptionsMap, SortOption } from "components/Filters/types";
import SearchInput from "components/SearchInput";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import { SEARCH_PLACEHOLDERS } from "constants/searchPlaceholders";
import PageInfoHeader from "ds/components/PageInfoHeader";
import { AnalyticsPageResources } from "hooks/useAnalytics/pages/resources";

import ScanResourcesSummary from "../components/Summary";
import { SCAN_RESOURCES_FILTERS_ORDER_KEY } from "../components/Table/constants";
import {
  SCAN_RESOURCES_FILTERS_TYPE,
  SCAN_RESOURCES_INITIAL_SORT_DIRECTION,
  SCAN_RESOURCES_INITIAL_SORT_OPTION,
} from "../constants";

type ScanResourcesFiltersLayoutProps = {
  children: ReactNode;
  filters: FilterItem[];
  filtersMap: FiltersItemsOptionsMap;
  sortOptions: SortOption[];
  filtersLoading: boolean;
  refetchActiveSections: (fields: string[]) => void;
  showSearch: boolean;
};

const ScanResourcesFiltersLayout = ({
  children,
  filters,
  filtersMap,
  sortOptions,
  filtersLoading,
  refetchActiveSections,
  showSearch,
}: ScanResourcesFiltersLayoutProps) => (
  <>
    <PageInfoHeader title="Resources">
      {showSearch && (
        <ViewHeaderWrapper direction="row" align="center">
          <SearchInput
            placeholder={SEARCH_PLACEHOLDERS.SCAN_RESOURCES}
            filtersOrderSettingsKey={SCAN_RESOURCES_FILTERS_ORDER_KEY}
          />
          <FiltersMobileTriggerButton />
        </ViewHeaderWrapper>
      )}
    </PageInfoHeader>

    <ScanResourcesSummary />

    <Filters
      filters={filters}
      filtersItemsOptionsMap={filtersMap}
      filtersLoading={filtersLoading}
      sortOptions={sortOptions}
      initialSortOption={SCAN_RESOURCES_INITIAL_SORT_OPTION}
      initialSortDirection={SCAN_RESOURCES_INITIAL_SORT_DIRECTION}
      pollActiveSections={refetchActiveSections}
      filtersOrderSettingsKey={SCAN_RESOURCES_FILTERS_ORDER_KEY}
      filtersType={SCAN_RESOURCES_FILTERS_TYPE}
      disableViews
    >
      <FiltersSplit>
        <FiltersSidebar analyticsPage={AnalyticsPageResources.Scans} />

        <FiltersContentWrapper>{children}</FiltersContentWrapper>
      </FiltersSplit>
    </Filters>
  </>
);

export default ScanResourcesFiltersLayout;
